import React, {
  useContext
} from 'react'
import { ApplicationFormContext } from '../../../ApplicationForm/ApplicationFormContext'
import AddressDetailsQuestionV1 from './AddressDetails.v1'
import AddressDetailsQuestionV2 from './AddressDetails.v2'
import { AddressDetailsProps } from './types'

export const AddressDetailsQuestion = ({
  existingDetails = {},
  entryId,
  disablePrevious = false,
  existingDisplayState = 'SEARCH_RESULTS',
  existingLoqateResults,
  existingPostcodeSearchLabel,
  existingPostcodeSearchAttempted = false,
  updateFollowingPrefillStep
}: AddressDetailsProps): JSX.Element => {
  const { featureSwitches } = useContext(ApplicationFormContext)
  const { addressRedesignV2 } = featureSwitches ?? {}

  if (addressRedesignV2) {
    return (
      <AddressDetailsQuestionV2
        existingDetails={existingDetails}
        entryId={entryId}
        disablePrevious={disablePrevious}
        existingDisplayState={existingDisplayState}
        existingLoqateResults={existingLoqateResults}
        existingPostcodeSearchLabel={existingPostcodeSearchLabel}
        existingPostcodeSearchAttempted={existingPostcodeSearchAttempted}
      />
    )
  }

  return (
    <AddressDetailsQuestionV1
      existingDetails={existingDetails}
      entryId={entryId}
      disablePrevious={disablePrevious}
      updateFollowingPrefillStep={updateFollowingPrefillStep}
    />
  )
}

export default AddressDetailsQuestion
